// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__D+Iu0","tableHeader":"Footer_tableHeader__q8BHr","tableData":"Footer_tableData__lMwfG"};